export default __webpack_public_path__ + "static/media/Chat-Numbers-System-06.619c8496.svg";